<script lang="ts">
    import { _ } from 'svelte-i18n';

    import TemplateHeaderDuo from '../../shared/TemplateHeaderDuo.svelte';
    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import { onMount } from 'svelte';
    import {
        ColumnSettingsApi,
        type ImportAnalyzeResponseType,
    } from '../ColumnSelectPro/ColumnSettingsApi';
    import { api } from '../../../stores/api';
    import { currentImport } from '../../shared/ColumnSelectPro/currentImport';
    import ImportAnalyze from './ImportAnalyze/ImportAnalyze.svelte';
    import { mainMenu } from '../../../stores/store';
    import { Navigation } from '../../utilities/Navigation';
    import { openModal } from 'svelte-modals';
    import ModalError from '../../shared/Modals/ModalError.svelte';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import ErrorInline from '../../shared/ErrorInline.svelte';
    import ButtonSecondary from '../../shared/ButtonSecondary.svelte';
    import IconBack from '../../shared/Icons/IconBack.svelte';
    import TemplateRow from '../../shared/TemplateRow.svelte';
    import { NotificationSystem } from '../NotificationSystem/NotificationSystem';
    import IconPending from '../../shared/Icons/IconPending.svelte';
    import { Umami } from '../../utilities/Umami';

    let analyze: ImportAnalyzeResponseType | null = null;
    let error: string = '';
    let processing: boolean = false;

    onMount(() => {
        reloadAnalyze();
    });

    function confirm() {
        processing = true;
        ColumnSettingsApi.confirm($api, $currentImport.id)
            .then(() => {
                // if ($currentImport?.file_type === 'connections') {
                //     $NotificationSystem.changeIntervalSeconds(2);
                // }
                Umami.event('import_confirm', { import_id: $currentImport.id });
                let link = $mainMenu.items.find(item => item.id === 'PageGeocoding')?.to || '/';
                console.info('AssignColumns: link', link);
                Navigation.navigate(link);
                processing = false;
            })
            .catch(err => {
                Umami.error('import_confirm', err, { import_id: $currentImport.id });
                console.warn('AssignColumns: data', $currentImport);
                console.warn('AssignColumns: Columns settings confirm error!', err);
                openModal(ModalError, { message: err });
                processing = false;
            });
    }

    function isConfirmEnabled(
        processing: boolean,
        analyze: ImportAnalyzeResponseType | null
    ): boolean {
        return (
            !processing &&
            analyze !== null &&
            analyze.uploaded_ignored.count === 0 &&
            analyze.needed_to_resolve_from_link.count === 0
        );
    }

    function isLimitExceeded(): boolean {
        return analyze !== null && analyze.max_items < analyze.total_uploaded.count;
    }

    function hasErrors(analyze: ImportAnalyzeResponseType | null): boolean {
        return analyze !== null && analyze.uploaded_ignored.count > 0;
    }

    function isCancelEnabled(
        processing: boolean,
        analyze: ImportAnalyzeResponseType | null
    ): boolean {
        return !processing && analyze !== null;
    }

    function reloadAnalyze() {
        analyze = null;
        console.log('PageImportAnalyze mounted');
        if ($currentImport && $currentImport.id !== null) {
            ColumnSettingsApi.analyze($api, $currentImport.id)
                .then(response => {
                    analyze = response;
                })
                .catch(error => {
                    console.error(error);
                    error = $_('import_analysis_error');
                });
        } else {
            error = $_('no_import_selected');
        }
    }
</script>

<TemplateStandard>
    <div slot="submenu"></div>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderDuo>
            <div slot="main-header">
                <TemplateRow>
                    <IconBack
                        on:click={() => {
                            window.history.back();
                        }}
                        scale={0.7}
                    />
                    {$_('Podsumowanie przed importem')}
                    {#if processing}
                        <IconPending scale={1} spin={true} />
                    {/if}
                </TemplateRow>
            </div>
            <div slot="main-buttons">
                <!--                <ButtonMain-->
                <!--                    text={$_('btn-next')}-->
                <!--                    on:click={confirm}-->
                <!--                    disabled={processing || analyze === null}-->
                <!--                />-->
            </div>
        </TemplateHeaderDuo>
    </div>
    <div slot="content">
        <div
            style="display: flex; align-items: center; justify-content: center; padding: 40px 20px; flex-direction: column;"
        >
            {#if error !== ''}
                <ErrorInline text={error} />
            {:else if analyze}
                <ImportAnalyze {analyze} {reloadAnalyze} />
            {:else}
                <div>{$_('Trwa analiza importu...')}</div>
            {/if}

            {#if analyze}
                {#if isLimitExceeded() && false}
                    <div style="margin: 20px 0;">
                        <ErrorInline
                            text={$_(
                                'Liczba elementów po imporcie przekroczy dozwolony limit. Skontaktuj się z działem handlowym, aby zmienić limity.'
                            )}
                        />
                    </div>
                {/if}
                {#if !processing && hasErrors(analyze)}
                    <div style="margin: 20px 0;">
                        <ErrorInline text={$_('Popraw błędy w pliku, aby kontynuować.')} />
                    </div>
                {/if}
                <div
                    style="display: flex; justify-content: space-between; width: 100%;
margin: 30px 0;"
                >
                    <ButtonSecondary
                        text={$_('Cancel')}
                        showIcon={false}
                        on:click={() => {
                            Umami.event('import_cancel', { import_id: $currentImport.id });
                            Navigation.navigate('/');
                        }}
                        disabled={!isCancelEnabled(processing, analyze)}
                    />
                    <ButtonMain
                        text={$_('Import')}
                        on:click={confirm}
                        disabled={!isConfirmEnabled(processing, analyze)}
                    />
                </div>
            {/if}
        </div>
    </div>
</TemplateStandard>

<style>
</style>
